export default "__VITE_ASSET__CPVaKa3K__"